import { Col, Divider, Row } from "antd";
import React from "react";
import ErrorLoading from "../../404/ErrorLoading";
import CardData from "../CardData";
import CardDescription from "../CardDescription";
import CardMenu from "../CardMenu";
import CardTitle from "../CardTitle";
import StyledSelect from "../StyledSelect";

export default function CardError({
  cardTitle,
  methodology,
  dataSubtitle,
  description,
  selectArray,
  language,
}) {
  return (
    <Row style={{ height: "100%" }}>
      <Col xs={24} lg={9}>
        <CardMenu>
          <div>
            <CardTitle
              title={cardTitle}
              methodology={methodology}
              language={language}
            />
            <Divider className="smaller-margins" />
            <CardData
              data={"---"}
              subtitle={dataSubtitle}
              date={(language === "en" ? "Date" : "Fecha") + ": ---"}
              lang={language}
            />

            {selectArray.map((select, key) => {
              return (
                <StyledSelect
                  key={key}
                  placeHolderText={select.placeHolderText}
                  language={language}
                  isDisabled={true}
                />
              );
            })}
            <CardDescription text={description ?? ""} />
          </div>
        </CardMenu>
      </Col>
      <Col xs={24} lg={15}>
        <ErrorLoading language={language} />
      </Col>
    </Row>
  );
}
